import ApiService from "./apiservice";

export const SectionsService = {
    GetAdminSectionDegree(payload) {
        return ApiService.get("Sections/GetAdminSectionDegree", payload);
    },
    GetAdmins() {
        return ApiService.get("Sections/GetAdmins");
    },
    GetSectionsList(payload) {
        return ApiService.get("GetSectionsList", payload);
    },
    GetSectionsForManager(payload) {
        return ApiService.get("Sections/GetSectionsForManager", payload);
    },
    GetAllSectionsForManager(payload) {
        return ApiService.get("Sections/GetAllSectionsForManager", payload);
    },
    GetAllSections() {
        return ApiService.get("Sections/GetAllSections");
    },
    GetDedicatedSectionForPersentPessonel(payload) {
        return ApiService.get("Sections/GetDedicatedSectionForPersentPessonel",payload);
    },
    CanChangePersonPermission(params) {
        return ApiService.get("sections/CanChangePersonPermission",params);
    },
    CanResetPersonPassword(params) {
        return ApiService.get("sections/CanResetPersonPassword",params);
    },
    IsOutOfGroup(params) {
        return ApiService.get("sections/IsOutOfGroup",params);
    },
    IsDublicatedAdmin(params) {
        return ApiService.get("sections/IsDublicatedAdmin",params);
    },
    AddSectionAdmin(params) {
        return ApiService.post("sections/AddSectionAdmin", null, params);
    },
    UpdateSectionAdmin(params) {
        return ApiService.post("sections/UpdateSectionAdmin", null, params);
    },
    DeleteSection(params) {
        return ApiService.post("sections/DeleteSection", null, params);
    },
    GetAdminSectionCode(params) {
        return ApiService.get("sections/GetAdminSectionCode",params);
    },
    IsExistInAdminList(params) {
        return ApiService.get("sections/IsExistInAdminList",params);
    },
    GetWebSectionsAdmins(params) {
        return ApiService.get("sections/GetWebSectionsAdmins",params);
    },
    GetWebSectionDetail(params) {
        return ApiService.get("sections/GetWebSectionDetail",params);
    },
    UpdateWebSectionProperties(params) {
        return ApiService.post("sections/UpdateWebSectionProperties", null, params);
    },
    findVacationPermission(params) {
        return ApiService.get("sections/findVacationPermission", params);
    },
    findMissionPermission(params) {
        return ApiService.get("sections/findMissionPermission", params);
    },
    findIOPermission(params) {
        return ApiService.get("sections/findIOPermission", params);
    },
    findExtraPermission(params) {
        return ApiService.get("sections/findExtraPermission", params);
    },
    FindSpecificExtraworkPermission(params) {
        return ApiService.get("sections/FindSpecificExtraworkPermission", params);
    },
    AddPatternDetailvacationPermission(params) {
        return ApiService.post("sections/AddPatternDetailvacationPermission", null, params);
    },
    AddPatternDetailMissionPermission(params) {
        return ApiService.post("sections/AddPatternDetailMissionPermission", null, params);
    },
    AddPatternDetailIoPermission(params) {
        return ApiService.post("sections/AddPatternDetailIoPermission", null, params);
    },
    AddPatternDetailExtraWorkPermission(params) {
        return ApiService.post("sections/AddPatternDetailExtraWorkPermission", null, params);
    },
    AddWebSectionDetailSpecificExtraWorkPermission(params) {
        return ApiService.post("sections/AddWebSectionDetailSpecificExtraWorkPermission", null, params);
    },
    DeletePatternDetailPermission(params) {
        return ApiService.post("sections/DeletePatternDetailPermission", null, params);
    },
    findSectionName(params) {
        return ApiService.get("sections/findSectionName", params);
    },
};